export default {"src":"/_next/static/media/profile-weakness.b4456639.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};